//#region
import { all, takeEvery } from 'redux-saga/effects';
import {
  actionTypes as sessionActionTypes,
  watchStartSession,
} from '../redux/modules/session';
import { SET_TOKEN, watchSetToken } from './modules/token';
import { actionTypes as knockActionTypes, watchKnock } from './modules/knock';
import { SHOW_ALERT, watchAlert } from './modules/alert';
import {
  actionTypes as sayCodeActionTypes,
  watchSayCode,
} from './modules/sayCode';
import { actionTypes as loginActionTypes, watchLogin } from './modules/login';
import {
  actionTypes as profileActionTypes,
  watchGetProfile,
} from './modules/profile';
import {
  actionTypes as servicesActionTypes,
  watchGetServices,
} from './modules/services';
import {
  actionTypes as userSiteActionTypes,
  watchGetUserSite,
} from './modules/site/userSite';
import {
  actionTypes as userSiteInfoActionTypes,
  watchGetUserSiteInfo,
} from './modules/site/userSiteInfo';
import {
  actionTypes as filtersActionTypes,
  watchGetFilters,
} from './modules/filters';
import {
  actionTypes as neighborhoodActionTypes,
  watchGetNeighborhood,
} from './modules/neighborhood';
import {
  actionTypes as citiesActionTypes,
  watchGetCities,
} from './modules/cities';
import {
  actionTypes as regionOfLocationActionTypes,
  watchGetRegionOfLocation,
} from './modules/regionOfLocation';
import {
  actionTypes as switchBusinessActionTypes,
  watchSwitchBusiness,
} from './modules/switchBusiness';
import {
  actionTypes as createBusinessActionTypes,
  watchCreateBusiness,
} from './modules/createBusiness';
import {
  actionTypes as postChainsActionTypes,
  watchGetPostChains,
} from './modules/postChain/list';
import {
  actionTypes as postChainDetailActionTypes,
  watchGetPostChainDetail,
} from './modules/postChain/get';
import {
  actionTypes as invoiceListActionTypes,
  watchGetInvoiceList,
} from './modules/invoice/list';
import {
  actionTypes as invoicePrepareActionTypes,
  watchGetInvoicePrepare,
} from './modules/invoice/prepare';
import {
  actionTypes as invoiceDetailActionTypes,
  watchGetInvoiceDetail,
} from './modules/invoice/detail';
import {
  actionTypes as businessDocumentListActionTypes,
  watchGetBusinessDocumentList,
} from './modules/businessDocumentList';
import {
  actionTypes as ipgMineActionTypes,
  watchGetMyIpg,
} from './modules/ipgMine';
import {
  actionTypes as campaignListActionTypes,
  watchGetCampaignList,
} from './modules/campaignList';
import {
  actionTypes as sliderListActionTypes,
  watchGetSliderList,
} from './modules/sliderList';
import {
  actionTypes as logoutActionTypes,
  watchLogout,
} from './modules/logout';
import {
  actionTypes as tilesListActionType,
  watchGetTilesList,
} from './modules/tilesList';
import {
  actionTypes as customerActionTypes,
  watchGetCustomers,
} from './modules/customers';
import {
  actionTypes as blogPostsActionTypes,
  watchGetBlogPosts,
} from './modules/blog/list';
import {
  actionTypes as blogCommentsActionTypes,
  watchGetBlogCommentsList,
} from './modules/blog/comments';
import {
  actionTypes as blogServicesActionTypes,
  watchGetBlogServices,
} from './modules/blog/services';
import {
  actionTypes as blogAuthorsActionTypes,
  watchGetBlogAuthors,
} from './modules/blog/authors';
import {
  actionTypes as appSliderListActionTypes,
  watchGetAppSliderList,
} from './modules/appSliderList';

import {
  actionTypes as tagsActionTypes,
  watchGetTags,
} from './modules/tags';



//#endregion imports

export default function* rootTask(client, store) {
  yield all([
    takeEvery(sessionActionTypes.load, watchStartSession, client, store),
    takeEvery(knockActionTypes.load, watchKnock, client),
    takeEvery(logoutActionTypes.load, watchLogout, client),
    takeEvery(SHOW_ALERT, watchAlert),
    takeEvery(postChainsActionTypes.load, watchGetPostChains, client),
    takeEvery(postChainDetailActionTypes.load, watchGetPostChainDetail, client),
    takeEvery(invoiceListActionTypes.load, watchGetInvoiceList, client),
    takeEvery(invoicePrepareActionTypes.load, watchGetInvoicePrepare, client),
    takeEvery(invoiceDetailActionTypes.load, watchGetInvoiceDetail, client),
    takeEvery(sayCodeActionTypes.load, watchSayCode, client),
    takeEvery(loginActionTypes.load, watchLogin, client, store),
    takeEvery(profileActionTypes.load, watchGetProfile, client, store),
    takeEvery(SET_TOKEN, watchSetToken, client),
    takeEvery(servicesActionTypes.load, watchGetServices, client),
    takeEvery(campaignListActionTypes.load, watchGetCampaignList, client),
    takeEvery(sliderListActionTypes.load, watchGetSliderList, client),
    takeEvery(userSiteActionTypes.load, watchGetUserSite, client),
    takeEvery(userSiteInfoActionTypes.load, watchGetUserSiteInfo, client),
    takeEvery(filtersActionTypes.load, watchGetFilters, client),
    takeEvery(neighborhoodActionTypes.load, watchGetNeighborhood, client),
    takeEvery(citiesActionTypes.load, watchGetCities, client),
    takeEvery(
      regionOfLocationActionTypes.load,
      watchGetRegionOfLocation,
      client
    ),
    takeEvery(switchBusinessActionTypes.load, watchSwitchBusiness, client),
    takeEvery(createBusinessActionTypes.load, watchCreateBusiness, client),
    takeEvery(
      businessDocumentListActionTypes.load,
      watchGetBusinessDocumentList,
      client
    ),
    takeEvery(ipgMineActionTypes.load, watchGetMyIpg, client),
    takeEvery(tilesListActionType.load, watchGetTilesList, client),
    takeEvery(customerActionTypes.load, watchGetCustomers, client),
    takeEvery(blogPostsActionTypes.load, watchGetBlogPosts, client),
    takeEvery(blogCommentsActionTypes.load, watchGetBlogCommentsList, client),
    takeEvery(blogServicesActionTypes.load, watchGetBlogServices, client),
    takeEvery(blogAuthorsActionTypes.load, watchGetBlogAuthors, client),
    takeEvery(appSliderListActionTypes.load, watchGetAppSliderList, client),
    takeEvery(tagsActionTypes.load, watchGetTags, client),
  ]);
}
